import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { Switch } from "antd";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/clients/column";
import View from "../../assets/View";
import Add from "../../assets/Add";
import { getclientlist } from "../../api/request/service";
import { ChangeClientStatusApi } from "../../api/request/clients/clients";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import AddClientModal from "./components/AddClientModal";

const Clients = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);

  const getClientList = async (page = 1) => {
    try {
      setIsLoading(true);
      const { data } = await getclientlist();
      if (data.status) {
        const clientData = data?.data?.map((item) => {
          return {
            ...item,
            statusTag: (
              <Switch
                checked={item?.status === "active"}
                onClick={() => handleClientStatus(item)}
                checkedChildren="On"
                unCheckedChildren="Off"
              />
            ),
            created_at: item?.created_at
              ? moment(item?.created_at).format("LL")
              : "",
            action: (
              <button
                onClick={() =>
                  navigate(`/client_details/${item?.id}`, {
                    state: { pipeline_temp_id: item?.pipeline_temp_id },
                  })
                }
              >
                <View />
              </button>
            ),
          };
        });
        setData(clientData);
        setTotal(data?.total_record);
        setCurrentPage(page);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getClientList();
  }, []);

  const handleClientStatus = (item) => {
    setSelectedClient(item);
    setIsStatusModalOpen(true);
  };

  const updateClientStatus = (id, status) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item?.id === id) {
          return {
            ...item,
            statusTag: (
              <Switch
                checked={status === "active"}
                onClick={() => handleClientStatus({ ...item, status })}
                checkedChildren="On"
                unCheckedChildren="Off"
              />
            ),
          };
        }
        return item;
      });
    });
  };

  const handleStatuChange = async () => {
    setIsStatusLoading(true);
    try {
      const status =
        selectedClient?.status === "active" ? "inactive" : "active";
      const params = { id: selectedClient?.id, status };
      const { data } = await ChangeClientStatusApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsStatusModalOpen(false);
        updateClientStatus(selectedClient?.id, status);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsStatusLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    getClientList(pagination?.current);
  };

  return (
    <div>
      <div className="border rounded-lg bg-White pb-5">
        <div className="flex items-center justify-between p-5">
          <p className="font-semibold text-xl">
            Clients {total ? `(${total})` : null}
          </p>

          <button
            className="bg-secondary text-White flex items-center gap-2 rounded-lg py-2 px-4"
            onClick={() => setIsModalOpen(true)}
          >
            <Add />
            <span>Add Client</span>
          </button>
        </div>

        <SkeletonTable
          columns={columns}
          data={data}
          searchingFields={["name", "email", "mobile_no"]}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>

      {/* Create client modal */}
      <AddClientModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        getClientList={getClientList}
      />

      {/* Confirmation modal for status */}
      <ConfirmationModal
        isOpen={isStatusModalOpen}
        setIsOpen={setIsStatusModalOpen}
        message="Are you sure, you want to change client status?"
        onConfirm={handleStatuChange}
        isLoading={isStatusLoading}
        loadingLabel="Changing status..."
      />
    </div>
  );
};

export default Clients;
